module.exports = __webpack_public_path__ + "static/media/1POLICY10.bd793325.jpg";